import React from 'react';
import AuthBackground from './components/AuthBackground';
import AuthBranding from './components/AuthBranding';

type Props = {
    children: React.ReactNode;
};

const AuthLayout = ({ children }: Props) => {
    return (
        <div className="min-h-screen overflow-hidden relative bg-gradient-to-br from-[#00BCD4] via-[#2196F3] to-[#0D47A1]">
            <AuthBackground />
            <div className="relative z-10 w-full max-w-7xl mx-auto min-h-screen grid lg:grid-cols-2 items-center gap-8 lg:gap-20 px-4 sm:px-8 py-10">
                {/* Branding – visible sur toutes les tailles */}
                <div>
                    <AuthBranding />
                </div>
                {/* Formulaire */}
                <div>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default AuthLayout;